<template>
  <svg
    width="26"
    height="51"
    viewBox="0 0 26 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.9365 38.044C18.9365 41.516 16.1711 44.3306 12.7597 44.3306C9.34844 44.3306 6.58298 41.516 6.58298 38.044C6.58298 35.7174 7.82567 33.6877 9.67137 32.6005V22.3274C9.67137 20.5914 11.0541 19.1841 12.7597 19.1841C14.4654 19.1841 15.8481 20.5914 15.8481 22.3274V32.6005C17.6938 33.6877 18.9365 35.7174 18.9365 38.044ZM22.0249 29.7286C23.9466 31.945 25.1133 34.8556 25.1133 38.044C25.1133 44.9884 19.5829 50.6172 12.7597 50.6172C12.7309 50.6172 12.701 50.6171 12.672 50.617C5.88704 50.569 0.371765 44.8842 0.406412 37.9785C0.42224 34.8157 1.58608 31.9298 3.4946 29.7286V9.75416C3.4946 4.54618 7.64278 0.324219 12.7597 0.324219C17.8767 0.324219 22.0249 4.54618 22.0249 9.75416V29.7286ZM20.4807 38.044C20.4807 34.6709 18.6113 32.9174 17.3923 31.5116V9.75416C17.3923 7.15435 15.3141 5.03919 12.7597 5.03919C10.2054 5.03919 8.12718 7.15435 8.12718 9.75416V31.5116C6.89839 32.9288 5.05568 34.6647 5.03889 38.0025C5.01727 42.3124 8.47114 45.8722 12.7042 45.9021L12.7597 45.9023C17.0171 45.9023 20.4807 42.3771 20.4807 38.044Z"
      fill="white"
    />
  </svg>
</template>

<script>
export default {
    name: 'FeelsLike'
}
</script>
